import _toConsumableArray from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/esnext.typed-array.to-reversed.js";
import "core-js/modules/esnext.typed-array.to-sorted.js";
import "core-js/modules/esnext.typed-array.with.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
/* eslint-disable */
function tab(len) {
  return _toConsumableArray(Array(len)).map(function (a) {
    return " ";
  }).join('');
}
export function exportXML(json, canvas) {
  var createFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var id = canvas.id || "flow";
  var name = canvas.name || "flow";
  var dataObjs = "";
  canvas.dataObjs.forEach(function (s) {
    dataObjs += "".concat(tab(4), "<dataObject id=\"").concat(s.id, "\" name=\"").concat(s.name, "\" itemSubjectRef=\"xsd:").concat(s.type, "\"></dataObject>\n");
  });
  var signals = "";
  canvas.signalDefs.forEach(function (s) {
    signals += "".concat(tab(2), "<signal id=\"").concat(s.id, "\" name=\"").concat(s.name, "\" flowable:scope=\"").concat(s.scope, "\"></signal>\n");
  });
  var messages = "";
  canvas.messageDefs.forEach(function (s) {
    messages += "".concat(tab(2), "<message id=\"").concat(s.id, "\" name=\"").concat(s.name, "\"></message>\n");
  });
  var BPMNShape = "";
  var BPMNEdge = "";
  var processXML = "".concat(tab(2), "<process id=\"").concat(id, "\" name=\"").concat(name, "\">\n");
  processXML += dataObjs;
  json.nodes.forEach(function (node) {
    BPMNShape += "".concat(tab(6), "<bpmndi:BPMNShape bpmnElement=\"").concat(node.id, "\" id=\"BPMNShape_").concat(node.id, "\">\n") + "".concat(tab(8), "<omgdc:Bounds width=\"").concat(node.size[0], "\" height=\"").concat(node.size[1], "\" x=\"").concat(node.x, "\" y=\"").concat(node.y, "\"></omgdc:Bounds>\n") + "".concat(tab(6), "</bpmndi:BPMNShape>\n");
    switch (node.clazz) {
      case 'start':
        processXML += "".concat(tab(4), "<startEvent id=\"").concat(node.id, "\"></startEvent>\n");
        break;
      case 'end':
        processXML += "".concat(tab(4), "<endEvent id=\"").concat(node.id, "\"></endEvent>\n");
        break;
      case 'userTask':
        {
          var assignments = "";
          if (node.assignValue && node.assignValue.length > 0) {
            if (node.assignType === 'person') {
              assignments += "flowable:candidateUsers=\"".concat(node.assignValue.join(','), "\"");
            } else if (node.assignType === 'assignee') {
              assignments += "flowable:assignee=\"".concat(node.assignValue[0], "\"");
            } else if (node.assignType === 'persongroup') {
              assignments += "flowable:candidateGroups=\"".concat(node.assignValue.join(','), "\"");
            }
          }
          processXML += "".concat(tab(4), "<userTask id=\"").concat(node.id, "\" name=\"").concat(node.label, "\" ").concat(assignments, "></userTask>\n");
          break;
        }
      case 'javaTask':
        {
          var javaClass = "";
          if (node.javaClass) {
            javaClass = "flowable:class=\"".concat(node.javaClass, "\"");
          }
          processXML += "".concat(tab(4), "<serviceTask id=\"").concat(node.id, "\" name=\"").concat(node.label, "\" ").concat(javaClass, "></serviceTask>\n");
          break;
        }
      case 'scriptTask':
        {
          var script = "";
          if (node.script) {
            script = "".concat(tab(6), "<script><![CDATA[").concat(node.script, "]]></script>\n");
          }
          processXML += "".concat(tab(4), "<scriptTask id=\"").concat(node.id, "\" name=\"").concat(node.label, "\">\n").concat(script).concat(tab(4), "</scriptTask>\n");
          break;
        }
      case 'receiveTask':
        processXML += "".concat(tab(4), "<receiveTask id=\"").concat(node.id, "\" name=\"").concat(node.label, "\"></receiveTask>\n");
        break;
      case 'mailTask':
        {
          var to = "".concat(tab(8), "<flowable:field name=\"to\">\n");
          to += "".concat(tab(10), "<flowable:string><![CDATA[").concat(node.to, "]]></flowable:string>\n");
          to += "".concat(tab(8), "</flowable:field>\n");
          var subject = "".concat(tab(8), "<flowable:field name=\"subject\">\n");
          subject += "".concat(tab(10), "<flowable:string><![CDATA[").concat(node.subject, "]]></flowable:string>\n");
          subject += "".concat(tab(8), "</flowable:field>\n");
          var text = "".concat(tab(8), "<flowable:field name=\"text\">\n");
          text += "".concat(tab(10), "<flowable:string><![CDATA[").concat(node.content, "]]></flowable:string>\n");
          text += "".concat(tab(8), "</flowable:field>\n");
          var extension = "".concat(tab(6), "<extensionElements>\n").concat(to).concat(subject).concat(text).concat(tab(6), "</extensionElements>\n");
          processXML += "".concat(tab(4), "<serviceTask id=\"").concat(node.id, "\" name=\"").concat(node.label, "\" flowable:type=\"mail\">\n").concat(extension).concat(tab(4), "</serviceTask>\n");
          break;
        }
      case 'timerStart':
        {
          var timer = "".concat(tab(6), "<timerEventDefinition>\n").concat(tab(8), "<timeCycle>").concat(node.cycle, "</timeCycle>\n").concat(tab(6), "</timerEventDefinition>\n");
          processXML += "".concat(tab(4), "<startEvent id=\"").concat(node.id, "\" isInterrupting=\"false\">\n").concat(timer).concat(tab(4), "</startEvent>\n");
          break;
        }
      case 'timerCatch':
        {
          var _timer = "".concat(tab(6), "<timerEventDefinition>\n").concat(tab(8), "<timeCycle>").concat(node.cycle, "</timeCycle>\n").concat(tab(6), "</timerEventDefinition>\n");
          processXML += "".concat(tab(4), "<intermediateCatchEvent id=\"").concat(node.id, "\">\n").concat(_timer).concat(tab(4), "</intermediateCatchEvent>\n");
          break;
        }
      case 'signalStart':
        {
          var signal = "".concat(tab(6), "<signalEventDefinition signalRef=\"").concat(node.signal, "\"></signalEventDefinition>\n");
          processXML += "".concat(tab(4), "<startEvent id=\"").concat(node.id, "\" isInterrupting=\"true\">\n").concat(signal).concat(tab(4), "</startEvent>\n");
          break;
        }
      case 'signalCatch':
        {
          var _signal = "".concat(tab(6), "<signalEventDefinition signalRef=\"").concat(node.signal, "\"></signalEventDefinition>\n");
          processXML += "".concat(tab(4), "<intermediateCatchEvent id=\"").concat(node.id, "\">\n").concat(_signal).concat(tab(4), "</intermediateCatchEvent>\n");
          break;
        }
      case 'messageStart':
        {
          var message = "".concat(tab(6), "<messageEventDefinition messageRef=\"").concat(node.message, "\"></messageEventDefinition>\n");
          processXML += "".concat(tab(4), "<startEvent id=\"").concat(node.id, "\" isInterrupting=\"true\">\n").concat(message).concat(tab(4), "</startEvent>\n");
          break;
        }
      case 'messageCatch':
        {
          var _message = "".concat(tab(6), "<messageEventDefinition messageRef=\"").concat(node.message, "\"></messageEventDefinition>\n");
          processXML += "".concat(tab(4), "<intermediateCatchEvent id=\"").concat(node.id, "\">\n").concat(_message).concat(tab(4), "</intermediateCatchEvent>\n");
          break;
        }
      case 'gateway':
        processXML += "".concat(tab(4), "<exclusiveGateway id=\"").concat(node.id, "\" name=\"").concat(node.label, "\"></exclusiveGateway>\n");
        break;
      case 'exclusiveGateway':
        processXML += "".concat(tab(4), "<exclusiveGateway id=\"").concat(node.id, "\" name=\"").concat(node.label, "\"></exclusiveGateway>\n");
        break;
      case 'parallelGateway':
        processXML += "".concat(tab(4), "<parallelGateway id=\"").concat(node.id, "\" name=\"").concat(node.label, "\"></parallelGateway>\n");
        break;
      case 'inclusiveGateway':
        processXML += "".concat(tab(4), "<inclusiveGateway id=\"").concat(node.id, "\" name=\"").concat(node.label, "\"></inclusiveGateway>\n");
        break;
      default:
        break;
    }
  });
  json.edges.forEach(function (edge) {
    BPMNEdge += "".concat(tab(6), "<bpmndi:BPMNEdge bpmnElement=\"").concat(edge.source, "_").concat(edge.sourceAnchor, "-").concat(edge.target, "_").concat(edge.targetAnchor, "\" ") + "id=\"BPMNEdge_".concat(edge.source, "_").concat(edge.sourceAnchor, "-").concat(edge.target, "_").concat(edge.targetAnchor, "\">\n") + "".concat(tab(8), "<omgdi:waypoint x=\"").concat(edge.startPoint.x, "\" y=\"").concat(edge.startPoint.y, "\"></omgdi:waypoint>\n") + "".concat(tab(8), "<omgdi:waypoint x=\"").concat(edge.endPoint.x, "\" y=\"").concat(edge.endPoint.y, "\"></omgdi:waypoint>\n") + "".concat(tab(6), "</bpmndi:BPMNEdge>\n");
    var condition = "";
    if (edge.conditionExpression) {
      condition = "".concat(tab(6), "<conditionExpression xsi:type=\"tFormalExpression\"><![CDATA[").concat(edge.conditionExpression, "]]></conditionExpression>\n");
    }
    processXML += "".concat(tab(4), "<sequenceFlow id=\"").concat(edge.source, "_").concat(edge.sourceAnchor, "-").concat(edge.target, "_").concat(edge.targetAnchor, "\" sourceRef=\"").concat(edge.source, "\" targetRef=\"").concat(edge.target, "\">").concat(condition, "</sequenceFlow>\n");
  });
  processXML += "".concat(tab(2), "</process>\n");
  var BPMNDiagram = "".concat(tab(2), "<bpmndi:BPMNDiagram id=\"BPMNDiagram_").concat(id, "\">\n") + "".concat(tab(4), "<bpmndi:BPMNPlane bpmnElement=\"").concat(id, "\" id=\"BPMNPlane_").concat(id, "\">\n").concat(BPMNShape).concat(BPMNEdge).concat(tab(4), "</bpmndi:BPMNPlane>\n") + "".concat(tab(2), "</bpmndi:BPMNDiagram>\n");
  var xml = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n";
  xml += "<definitions xmlns=\"http://www.omg.org/spec/BPMN/20100524/MODEL\" " + "xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" " + "xmlns:xsd=\"http://www.w3.org/2001/XMLSchema\" " + "xmlns:flowable=\"http://flowable.org/bpmn\" " + "xmlns:bpmndi=\"http://www.omg.org/spec/BPMN/20100524/DI\" " + "xmlns:omgdc=\"http://www.omg.org/spec/DD/20100524/DC\" " + "xmlns:omgdi=\"http://www.omg.org/spec/DD/20100524/DI\" " + "typeLanguage=\"http://www.w3.org/2001/XMLSchema\" " + "expressionLanguage=\"http://www.w3.org/1999/XPath\" " + "targetNamespace=\"http://www.flowable.org/processdef\">\n";
  xml += signals;
  xml += messages;
  xml += processXML;
  xml += BPMNDiagram;
  xml += "</definitions>";
  if (createFile) {
    downloadFile(xml, 'application/xml;charset=utf-8;', "".concat(name, ".bpmn20.xml"));
  }
  return xml;
}
export function exportImg(canvasPanel, filename) {
  var createFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  filename = filename || 'flow';
  var canvas = canvasPanel.querySelector('canvas');
  var context = canvas.getContext('2d');
  var imgData = context.getImageData(0, 0, canvas.width, canvas.height).data;
  var left = canvas.width;
  var right = 0;
  var top = canvas.height;
  var bottom = 0;
  for (var i = 0; i < canvas.width; i++) {
    for (var j = 0; j < canvas.height; j++) {
      var pos = (i + canvas.width * j) * 4;
      if (imgData[pos] > 0 || imgData[pos + 1] > 0 || imgData[pos + 2] || imgData[pos + 3] > 0) {
        bottom = Math.max(j, bottom); // 找到有色彩的最下端
        right = Math.max(i, right); // 找到有色彩的最右端
        top = Math.min(j, top); // 找到有色彩的最上端
        left = Math.min(i, left); // 找到有色彩的最左端
      }
    }
  }

  var c = document.createElement('canvas');
  // 四周空白余量
  var blankWidth = 60;
  c.width = right - left + blankWidth * 2;
  c.height = bottom - top + blankWidth * 2;
  var ctx = c.getContext('2d');
  // 设置白底
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.drawImage(canvas, left - blankWidth, top - blankWidth, c.width, c.height, 0, 0, c.width, c.height);
  var data = c.toDataURL("image/jpeg");
  if (createFile) {
    var parts = data.split(';base64,');
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var uInt8Array = new Uint8Array(raw.length);
    for (var _i = 0; _i < raw.length; ++_i) {
      uInt8Array[_i] = raw.charCodeAt(_i);
    }
    downloadFile(uInt8Array, contentType, "".concat(filename, ".jpg"));
  }
  return data;
}
function downloadFile(data, type, filename) {
  var blob = new Blob([data], {
    type: type
  });
  var link = document.createElement('a');
  if (link.download !== undefined) {
    var url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}